import React, { lazy } from 'react';

const BankAccountForm = lazy(() =>
  import(
    'containers/CompanySetupModule/BankAccountModule/BankAccountForm'
  ).then(module => ({ default: module.BankAccountForm })),
);

const BankAccountListing = lazy(() =>
  import(
    'containers/CompanySetupModule/BankAccountModule/BankAccountListing'
  ).then(module => ({ default: module.BankAccountListing })),
);

const BankAccountDetail = lazy(() =>
  import(
    'containers/CompanySetupModule/BankAccountModule/BankAccountDetail'
  ).then(module => ({ default: module.BankAccountDetail })),
);

const bankAccountRoutes = [
  {
    props: {
      exact: true,
      path: '/company-setup/submenu/:CompanyID/bank-account/new',
    },
    component: <BankAccountForm mode="add" type="company-setup" />,
  },
  {
    props: {
      exact: true,
      path: '/company-setup/submenu/:CompanyID/bank-account',
    },
    component: <BankAccountListing type="company-setup" />,
  },
  {
    props: {
      exact: true,
      path:
        '/company-setup/submenu/:CompanyID/bank-account/detail/:bankAccountID',
    },
    component: <BankAccountDetail type="company-setup" />,
  },
  {
    props: {
      exact: true,
      path:
        '/company-setup/submenu/:CompanyID/bank-account/edit/:bankAccountID',
    },
    component: <BankAccountForm mode="edit" type="company-setup" />,
  },
];

export default bankAccountRoutes;
